export default __webpack_public_path__ + "static/media/ic-alert.279607c0.svg";